import React from 'react';
import '../../styles/onboardingFlow/onboardingComponents/questionCard.scss';

type Props = {
  prompt: string;
  isSelected: boolean;
  isSubmitting: boolean;
  onClick: () => void;
};

const QuestionCard: React.FC<Props> = ({
  prompt,
  isSelected,
  isSubmitting,
  onClick,
}) => {
  return (
    <div
      className={`questionCard ${isSelected ? 'questionCard--selected' : ''} ${
        isSubmitting ? 'questionCard--disabled' : ''
      }`}
      onClick={isSubmitting ? undefined : onClick}
      onKeyDown={(e) => {
        if (!isSubmitting && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
      role='button'
      tabIndex={0}
      aria-pressed={isSelected}
      aria-disabled={isSubmitting}
    >
      <p className='questionCard__text'>{prompt}</p>
    </div>
  );
};

export default QuestionCard;
